import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {
  IndicatorDetailVm,
  IndicatorTabVm,
  ScoreDevelopmentChipVm,
  ScoreDevelopmentVm,
  ScoreDistributionSegmentVm,
  StatementResponsesVm,
  StatementsVm,
  StatementVm
} from '../../models/team-dynamic.vm';
import {StatementFilters} from '../statements/statements.component';

@Component({
  selector: 'app-indicator-view',
  templateUrl: './indicator-view.component.html',
  styleUrls: ['./indicator-view.component.scss']
})
export class IndicatorViewComponent implements OnChanges {
  @Input() tabs: IndicatorTabVm[] = [];
  @Input() selectedUuid: string | null = null;
  @Input() detail: IndicatorDetailVm | null = null;
  @Input() loading: boolean = false;
  @Input() scoreDevelopment: ScoreDevelopmentVm = {labels: [], values: []};
  @Input() statements: StatementsVm | null = null;
  @Input() loadingStatements: boolean = false;
  @Input() statementResponses: StatementResponsesVm | null = null;

  @Output() categorySelected = new EventEmitter<string>();
  @Output() statementFiltersChanged = new EventEmitter<StatementFilters>();
  @Output() statementOpened = new EventEmitter<StatementVm>();

  tabItems: MenuItem[] = [];
  activeTabItem: MenuItem = {};
  chartChips: ScoreDevelopmentChipVm[] = [];
  distributionLabels: ScoreDistributionSegmentVm[] = [];
  iconStyle: { [key: string]: string } = {};
  visibleToTeam: boolean = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabs'] || changes['selectedUuid']) {
      this.buildTabItems();
    }
    if (changes['detail']) {
      this.buildDetailViews();
    }
  }

  trackByColorName(index: number, segment: ScoreDistributionSegmentVm) {
    return segment.colorName;
  }

  onStatementFiltersChanged(filters: StatementFilters) {
    this.statementFiltersChanged.emit(filters);
  }

  onStatementOpened(statement: StatementVm) {
    this.statementOpened.emit(statement);
  }

  private buildTabItems() {
    this.tabItems = this.tabs.map(tab => ({
      label: tab.title,
      state: {uuid: tab.uuid, color: tab.color},
      command: () => this.categorySelected.emit(tab.uuid)
    }));
    this.activeTabItem = this.tabItems.find(item => item.state?.['uuid'] === this.selectedUuid)
      ?? this.tabItems[0] ?? {};
  }

  private buildDetailViews() {
    if (!this.detail) {
      this.chartChips = [];
      this.distributionLabels = [];
      this.iconStyle = {};
      return;
    }
    this.distributionLabels = this.detail.distribution.filter(segment => segment.percentage > 0);
    this.chartChips = [{
      uuid: this.detail.uuid,
      title: this.detail.title,
      icon: this.detail.icon,
      color: this.detail.color
    }];
    this.iconStyle = {
      '-webkit-mask-image': 'url(' + this.detail.icon + ')',
      'mask-image': 'url(' + this.detail.icon + ')',
      'background-color': '#FFFFFF'
    };
  }
}
